import VueRouter from 'vue-router';
import { onServiceWorkerRegistration } from '@/plugins/updater';
import guard from './guard';
import routes from '../views';

const mode = 'history';

/**
 * @description Роутер.
 * @constructor
 * @augments VueRouter
 */
export default function Router() {
  VueRouter.call(this, { mode, routes });
  this.beforeEach(guard);
  this.afterEach(() => {
    if (navigator.serviceWorker && navigator.serviceWorker.controller) {
      navigator.serviceWorker.getRegistration().then((registration) => {
        if (registration) {
          onServiceWorkerRegistration(registration);
        }
      });
    }
  });
}

Router.prototype = Object.create(VueRouter.prototype);
